function f(l) {
  return function(e, t) {
    var d = t != null && t.context ? String(t.context) : "standalone", a;
    if (d === "formatting" && l.formattingValues) {
      var u = l.defaultFormattingWidth || l.defaultWidth, n = t != null && t.width ? String(t.width) : u;
      a = l.formattingValues[n] || l.formattingValues[u];
    } else {
      var r = l.defaultWidth, v = t != null && t.width ? String(t.width) : l.defaultWidth;
      a = l.values[v] || l.values[r];
    }
    var i = l.argumentCallback ? l.argumentCallback(e) : e;
    return a[i];
  };
}
export {
  f as default
};
